export const DEFAULT_DETAILS = {
  jobExpectations: '',
  equipments: [''],
  requiredCredentials: null,
};

export default class DetailsSerializer {
  static deserialize(details) {
    if (!details) return DEFAULT_DETAILS;

    const credentials =
      details.required_credentials?.length === 1 && details.required_credentials[0] === ''
        ? []
        : details.required_credentials;

    return {
      jobExpectations: details.job_expectations,
      equipments: details.equipments || [''],
      requiredCredentials: credentials,
    };
  }

  static serialize(details) {
    if (!details) return {};

    return {
      job_expectations: details.jobExpectations,
      equipments: details.equipments || [''],
      required_credentials: details.requiredCredentials,
    };
  }
}
